import React, { useState } from 'react';
import { FaCircle } from "react-icons/fa6";

const PrizesData = () => {

    const [showComponent, setShowComponent] = useState('A');

    let content;

    const handleComponentA = () => {
        setShowComponent('A')
    }
    const handleComponentB = () => {
        setShowComponent('B')
    }
    const handleComponentC = () => {
        setShowComponent('C')
    }

    switch (showComponent) {
        case 'A':
            content = (
                <>
                    <div >
                        <table className="table" style={{ textAlign: "left", width: 500 }}>
                            <thead>
                                <tr>
                                    <th><h2>Match</h2></th>
                                    <th><h2>Prizes</h2></th>
                                </tr>
                            </thead>
                            <tbody >
                                <tr>
                                    <td>
                                        <FaCircle style={{ fontSize: 25, color: "green", marginLeft: 2 }} />
                                        <FaCircle style={{ fontSize: 25, color: "green", marginLeft: 2 }} />
                                        <FaCircle style={{ fontSize: 25, color: "green", marginLeft: 2 }} />
                                        <FaCircle style={{ fontSize: 25, color: "green", marginLeft: 2 }} />
                                        <FaCircle style={{ fontSize: 25, color: "green", marginLeft: 2 }} />
                                    </td>
                                    <td><h3>1 Lakh Rupees</h3></td>
                                </tr>
                                <tr>
                                    <td>
                                        <FaCircle style={{ fontSize: 25, color: "green", marginLeft: 2 }} />
                                        <FaCircle style={{ fontSize: 25, color: "green", marginLeft: 2 }} />
                                        <FaCircle style={{ fontSize: 25, color: "green", marginLeft: 2 }} />
                                        <FaCircle style={{ fontSize: 25, color: "green", marginLeft: 2 }} />
                                    </td>
                                    <td><h3>500 Rupees BookMyShow</h3></td>
                                </tr>
                                <tr>
                                    <td>
                                        <FaCircle style={{ fontSize: 25, color: "green", marginLeft: 2 }} />
                                        <FaCircle style={{ fontSize: 25, color: "green", marginLeft: 2 }} />
                                        <FaCircle style={{ fontSize: 25, color: "green", marginLeft: 2 }} />
                                    </td>
                                    <td><h3>250 Rupees BookMyShow</h3></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <h3>Terms & Conditions Apply:</h3>
                        <h4>*1st Prize if more than 1 user predicts same number the amount would be split equally.</h4>
                        <h4>*2nd & 3rd Prize would be given for first 10 winners only.</h4>
                    </div>
                </>
            );
            break;
        case 'B':
            content = (
                <div>
                    <h2>Coming Soon</h2>
                </div>
            );
            break;
        case 'C':
            content = (
                <div>
                    <h2>Coming Soon</h2>
                </div>
            );
            break;
        default:
            content = (
                <div></div>
            )
    }

    return (
        <div style={{ textAlign: "left", marginLeft: 100 }}>
            <h1>List of Prizes you can win !</h1>

            <div >
                <button onClick={handleComponentA} className={showComponent === 'A' ? "btn btn-success rounded-50 mx-1" : "btn btn-secondary rounded-50 mx-1"}>DAILY</button>
                <button onClick={handleComponentB} className={showComponent === 'B' ? "btn btn-success rounded-50 mx-1" : "btn btn-secondary rounded-50 mx-1"}>MONTHLY</button>
                <button onClick={handleComponentC} className={showComponent === 'C' ? "btn btn-success rounded-50 mx-1" : "btn btn-secondary rounded-50 mx-1"}>YEARLY </button>
            </div>
            {content}
        </div >
    )
}

export default PrizesData;